/* ============================================
   PRODUCT PAGE — Animations & Interactions
   ============================================ */

(function () {
  'use strict';

  /* ---- Pulsing green dot for stock status ---- */
  var stockIn = document.querySelectorAll('.stock-status__in-stock');
  stockIn.forEach(function (el) {
    if (!el.querySelector('.noxor-stock-dot')) {
      var dot = document.createElement('span');
      dot.className = 'noxor-stock-dot';
      el.insertBefore(dot, el.firstChild);
    }
  });

  /* ---- Trust bar scroll reveal ---- */
  var trustBar = document.querySelector('.noxor-trust-bar');
  if (trustBar) {
    trustBar.style.opacity = '0';
    trustBar.style.transform = 'translateY(12px)';
    trustBar.style.transition = 'opacity 0.5s ease, transform 0.5s ease';

    var trustObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            trustObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    trustObserver.observe(trustBar);
  }

  /* ---- Sticky quick-add close button ---- */
  var quickAddObserver = new MutationObserver(function () {
    var quickAdd = document.querySelector('product-quick-add');
    if (quickAdd && !quickAdd.querySelector('.noxor-sticky-close')) {
      var closeBtn = document.createElement('button');
      closeBtn.className = 'noxor-sticky-close';
      closeBtn.innerHTML = '\u2715';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.addEventListener('click', function () {
        quickAdd.classList.add('noxor-sticky-hidden');
      });
      quickAdd.appendChild(closeBtn);
      quickAddObserver.disconnect();
    }
  });

  quickAddObserver.observe(document.body, { childList: true, subtree: true });

  /* ---- Premium FAQ: header injection + scroll reveal ---- */
  var faqSection = document.querySelector('[id*="__product-tabs"]');
  if (faqSection) {
    var productTabs = faqSection.querySelector('product-tabs');
    var faqAccordion = faqSection.querySelector('faqs-accordion');

    /* Inject header before the accordion */
    if (faqAccordion && !faqSection.querySelector('.noxor-faq-eyebrow')) {
      var eyebrow = document.createElement('span');
      eyebrow.className = 'noxor-faq-eyebrow';
      eyebrow.textContent = 'Got Questions?';

      var titleWrap = document.createElement('div');
      titleWrap.className = 'noxor-faq-title-wrapper';
      var titleH2 = document.createElement('h2');
      titleH2.textContent = 'Frequently Asked Questions';
      titleWrap.appendChild(titleH2);

      var insertTarget = productTabs || faqSection;
      insertTarget.insertBefore(titleWrap, insertTarget.firstChild);
      insertTarget.insertBefore(eyebrow, insertTarget.firstChild);
    }

    /* Scroll reveal — stagger FAQ items with CSS classes */
    var faqItems = faqSection.querySelectorAll('faqs-accordion details');
    faqItems.forEach(function (item) {
      item.classList.add('noxor-faq-reveal-ready');
    });

    if (faqItems.length > 0) {
      var faqObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var item = entry.target;
              var index = Array.from(faqItems).indexOf(item);
              setTimeout(function () {
                item.classList.remove('noxor-faq-reveal-ready');
                item.classList.add('noxor-faq-revealed');
              }, index * 100);
              faqObserver.unobserve(item);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      faqItems.forEach(function (item) { faqObserver.observe(item); });
    }

    /* Smooth slide-down on details open */
    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (this.open) {
          var content = this.querySelector('.faq-content');
          if (content) {
            content.style.animation = 'noxorFaqSlideDown 0.3s ease forwards';
          }
        }
      });
    });
  }

  /* ---- FBT carousel dots on mobile ---- */
  if (window.innerWidth <= 749) {
    var fbtGrid = document.querySelector('[id$="__fbt"] .items-grid');
    if (fbtGrid) {
      var fbtCards = fbtGrid.querySelectorAll('.grid-item');
      if (fbtCards.length > 1) {
        var dotsContainer = document.createElement('div');
        dotsContainer.className = 'noxor-fbt-dots';
        fbtCards.forEach(function (_, i) {
          var dot = document.createElement('div');
          dot.className = 'noxor-fbt-dot' + (i === 0 ? ' active' : '');
          dotsContainer.appendChild(dot);
        });
        fbtGrid.parentNode.insertBefore(dotsContainer, fbtGrid.nextSibling);

        fbtGrid.addEventListener('scroll', function () {
          var cardWidth = fbtCards[0].offsetWidth + 16;
          var index = Math.round(fbtGrid.scrollLeft / cardWidth);
          var dots = document.querySelectorAll('.noxor-fbt-dot');
          dots.forEach(function (dot, i) {
            dot.classList.toggle('active', i === index);
          });
        });
      }
    }
  }
})();
